/**
 * Krakens horde deck.
 * Source: hordemagic.com (~310 cards: ~184 tokens / ~125 nontoken).
 * Scaled to ~100 cards preserving the ~3:2 token:nontoken ratio.
 * All nontoken card names verified against local card DB.
 * Deviations:
 *   - "Marit Lage" DROPPED: stored as layout='token' in DB, not a playable nontoken card.
 *     Substituted with "Marit Lage's Slumber" (normal card that generates the avatar).
 *   - "Runo Stromkirk" stored as "Runo Stromkirk // Krothuss, Lord of the Deep" in DB;
 *     DFC fallback in resolve-horde endpoint handles it.
 *   - "Tidal Terror" (starred) ✓ exists in DB as Creature — Octopus.
 *   - "Monstrosity of the Lake" ✓ exists in DB as Legendary Creature — Kraken.
 *   - "The Watcher in the Water" ✓ exists in DB as Legendary Creature — Kraken.
 *   - Token "Kraken 1/1 trample" verified: cb727dec (Trample Kraken token).
 *   - Token "Kraken (8/8)" and "Kraken (9/9)" collapsed to two plain Kraken token printings
 *     since the DB stores them by type without P/T differentiation.
 * Tokens used:
 *   - Tentacle: 3d9415be
 *   - Squid: 2c7e1ec8
 *   - Kraken (plain): 622397a1, ca17c7b2
 *   - Kraken (trample): cb727dec
 */
export const krakensDeck = {
    id: 'krakens',
    name: 'Depths of Despair',
    description: 'Tentacled horrors from the deep rise to drag the world into the abyss.',
    cards: [
        // ── Tokens (60 total) ────────────────────────────────────────────────────
        { name: 'Tentacle', quantity: 20, isToken: true, scryfallId: '3d9415be-356d-45a5-a62b-a75368629481' },
        { name: 'Squid', quantity: 6, isToken: true, scryfallId: '2c7e1ec8-ee84-4806-bd89-defd79902e41' },
        // Plain Krakens (stand-in for 8/8 and 9/9 variants)
        { name: 'Kraken', quantity: 14, isToken: true, scryfallId: '622397a1-6513-44b9-928a-388be06d4022' },
        { name: 'Kraken', quantity: 4, isToken: true, scryfallId: 'ca17c7b2-180a-4bd1-9ab2-152f8f656dba' },
        // Trample Krakens (scaled from 64 source copies)
        { name: 'Kraken', quantity: 16, isToken: true, scryfallId: 'cb727dec-dd82-4072-b2ec-a4e31b58752f' },
        // ── Legendary Creatures (12) ─────────────────────────────────────────────
        { name: 'Koma, Cosmos Serpent', quantity: 1, isToken: false },
        { name: 'Runo Stromkirk', quantity: 1, isToken: false },
        { name: 'Wrexial, the Risen Deep', quantity: 1, isToken: false },
        { name: 'Gyruda, Doom of Depths', quantity: 1, isToken: false },
        { name: 'The Watcher in the Water', quantity: 1, isToken: false },
        { name: 'Octavia, Living Thesis', quantity: 1, isToken: false },
        { name: 'Tromokratis', quantity: 3, isToken: false },
        { name: 'Brinelin, the Moon Kraken', quantity: 1, isToken: false },
        { name: 'Slinn Voda, the Rising Deep', quantity: 1, isToken: false },
        { name: "Marit Lage's Slumber", quantity: 1, isToken: false },
        // ── Sea Creatures (25) ───────────────────────────────────────────────────
        { name: 'Serpent of Yawning Depths', quantity: 1, isToken: false },
        { name: 'Denizen of the Deep', quantity: 1, isToken: false },
        { name: 'Inkwell Leviathan', quantity: 1, isToken: false },
        { name: 'Elder Deep-Fiend', quantity: 1, isToken: false },
        { name: 'Fleet Swallower', quantity: 1, isToken: false },
        { name: 'Aboleth Spawn', quantity: 1, isToken: false },
        { name: 'Man-o\'-War', quantity: 5, isToken: false },
        { name: 'Nadir Kraken', quantity: 4, isToken: false },
        { name: 'Reservoir Kraken', quantity: 1, isToken: false },
        { name: 'Shipbreaker Kraken', quantity: 1, isToken: false },
        { name: 'Spawning Kraken', quantity: 1, isToken: false },
        { name: 'Tolarian Kraken', quantity: 4, isToken: false },
        { name: 'Hullbreaker Horror', quantity: 1, isToken: false },
        { name: 'Kederekt Leviathan', quantity: 1, isToken: false },
        { name: 'Monstrosity of the Lake', quantity: 1, isToken: false },
        // ── Spells & Enchantments (3) ────────────────────────────────────────────
        { name: 'Whelming Wave', quantity: 1, isToken: false },
        { name: 'Ominous Seas', quantity: 1, isToken: false },
        { name: 'Tidal Influence', quantity: 1, isToken: false },
    ],
};
//# sourceMappingURL=krakens.js.map